import { ShieldIcon } from '@/common/assets';

export default function Shield() {
  return (
    <div className="pointer-events-none absolute left-1/2 top-px z-0 h-[63px] w-[49px] -translate-x-1/2">
      <img
        src={ShieldIcon}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full max-w-none object-cover"
        draggable={false}
      />
    </div>
  );
}
